export enum SentryArea {
  PHISHING = 'phishing',
  AWARENESS = 'awareness',
  SECURITY_CULTURE = 'security-culture',
  AUTH = 'auth',
  REPORTING = 'reporting',
  INTEGRATIONS = 'integrations',
  ACCOUNTS = 'accounts',
  USERS = 'users',
  PLATFORM = 'platform',
}

export const SENTRY_AREA_TAG = 'area';

const ROUTE_AREAS: ReadonlyArray<readonly [string, SentryArea]> = [
  ['/campaigns', SentryArea.PHISHING],
  ['/campaign-master-templates', SentryArea.PHISHING],
  ['/email-templates', SentryArea.PHISHING],
  ['/landing-page-templates', SentryArea.PHISHING],
  ['/redirect-page-templates', SentryArea.PHISHING],
  ['/sender-profiles', SentryArea.PHISHING],
  ['/phishing-analytics', SentryArea.PHISHING],
  ['/phishing-intro', SentryArea.PHISHING],
  ['/phishing-global-settings', SentryArea.PHISHING],
  ['/phishing-simulations', SentryArea.PHISHING],
  ['/dashboard/learner/phishing', SentryArea.PHISHING],

  ['/content', SentryArea.AWARENESS],
  ['/courses', SentryArea.AWARENESS],
  ['/resources', SentryArea.AWARENESS],
  ['/custom-materials', SentryArea.AWARENESS],
  ['/enrollment', SentryArea.AWARENESS],
  ['/policies-and-documents', SentryArea.AWARENESS],
  ['/policies-and-documents-schedule', SentryArea.AWARENESS],
  ['/awareness-training-analytics', SentryArea.AWARENESS],
  ['/reports-awareness', SentryArea.AWARENESS],
  ['/dashboard/learner', SentryArea.AWARENESS],
  ['/account/training-settings', SentryArea.AWARENESS],
  ['/accounts/training-settings', SentryArea.AWARENESS],
  ['/accounts/content', SentryArea.AWARENESS],
  ['/accounts/documents', SentryArea.AWARENESS],

  ['/security-culture', SentryArea.SECURITY_CULTURE],
  ['/security-culture-survey', SentryArea.SECURITY_CULTURE],
  ['/security-culture-surveys', SentryArea.SECURITY_CULTURE],
  ['/survey', SentryArea.SECURITY_CULTURE],

  ['/login', SentryArea.AUTH],
  ['/logout', SentryArea.AUTH],
  ['/complete-sign-in', SentryArea.AUTH],
  ['/silent-renew-callback', SentryArea.AUTH],
  ['/unauthorized', SentryArea.AUTH],
  ['/accounts/sso', SentryArea.AUTH],
  ['/accounts/saml-config', SentryArea.AUTH],

  ['/dashboard/admin', SentryArea.REPORTING],
  ['/reports-summary', SentryArea.REPORTING],

  ['/hubspot-sync', SentryArea.INTEGRATIONS],
  ['/hubspot-errors', SentryArea.INTEGRATIONS],
  ['/book-a-meeting', SentryArea.INTEGRATIONS],
  ['/account/integrations', SentryArea.INTEGRATIONS],
  ['/accounts/integrations', SentryArea.INTEGRATIONS],
  ['/accounts/azure-ad', SentryArea.INTEGRATIONS],

  ['/account', SentryArea.ACCOUNTS],
  ['/accounts', SentryArea.ACCOUNTS],
  ['/branches', SentryArea.ACCOUNTS],
  ['/groups', SentryArea.ACCOUNTS],
  ['/resellers', SentryArea.ACCOUNTS],
  ['/features', SentryArea.ACCOUNTS],
  ['/domain-verification', SentryArea.ACCOUNTS],

  ['/users', SentryArea.USERS],
  ['/admin-tasks', SentryArea.USERS],
  ['/profile', SentryArea.USERS],
  ['/learner/profile', SentryArea.USERS],
  ['/find-user', SentryArea.USERS],

  ['/system-emails', SentryArea.PLATFORM],
  ['/tools', SentryArea.PLATFORM],
  ['/not-found', SentryArea.PLATFORM],
  ['/', SentryArea.PLATFORM],
];

const BY_SPECIFICITY = [...ROUTE_AREAS].sort(([a], [b]) => b.length - a.length);

const normalize = (pathname: string): string => {
  const path = pathname.split(/[?#]/)[0];
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
};

export const matchSentryArea = (pathname: string): SentryArea | undefined => {
  const path = normalize(pathname);

  return BY_SPECIFICITY.find(
    ([prefix]) => path === prefix || path.startsWith(`${prefix}/`),
  )?.[1];
};

export const resolveSentryArea = (pathname: string): SentryArea =>
  matchSentryArea(pathname) ?? SentryArea.PLATFORM;
